//项目定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 项目类型
 */
class Type extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}

export const TYPE = new Type();

/**
 * 项目状态
 */
class State extends UltMeta {
    STAY_ASSIGN = new Meta(1, "待指派", "待处理");
    PENDING = new Meta(2, "待处理", "处理中");
    PROCESSING = new Meta(3, "交付中", "交付中");
    DRAFT = new Meta(4, "草稿", "草稿");
    FINISHED = new Meta(5, "已完成", "已完成");
    CLOSED = new Meta(6, "已关闭", "已关闭");
}

export const STATE = new State();

/**
 * 服务费结算状态
 */
class ServiceCostState extends UltMeta {
    UNSETTLED = new Meta(1, "未结算");
    SETTLED = new Meta(2, "已结算");
    AUTO_SETTLED = new Meta(3, "自动结算");
}

export const SERVICE_COST_STATE = new ServiceCostState();
